"use client";

import Image from "next/image";

const Partners = () => {
  return (
    <div className="border-y border-gray-200 bg-white py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10">
          <Image
            alt="Princeton University"
            src="/images/partners/princeton.png"
            width={250}
            height={120}
            className="h-25 w-auto scale-125 object-contain"
          />
          <Image
            alt="PSE"
            src="/images/partners/PSE.png"
            width={250}
            height={120}
            className="h-13 w-auto object-contain"
          />
          <Image
            alt="New York University"
            src="/images/partners/nyu.png"
            width={250}
            height={120}
            className="h-15 w-auto object-contain"
          />
          <Image
            alt="Mines Telecom"
            src="/images/partners/MinesTelecom.png"
            width={250}
            height={120}
            className="h-25 w-auto object-contain"
          />
          <Image
            alt="Max Planck"
            src="/images/partners/MaxPlanck.png"
            width={250}
            height={120}
            className="h-25 w-auto scale-150 object-contain"
          />
          <Image
            alt="INCTDD"
            src="/images/partners/inctdd (1).png"
            width={250}
            height={120}
            className="h-15 w-auto object-contain"
          />
          <Image
            alt="Columbia University"
            src="/images/partners/columbia.png"
            width={250}
            height={120}
            className="h-30 w-auto scale-125 object-contain"
          />
          <Image
            alt="Code for Africa"
            src="/images/partners/codeforafrica.png"
            width={250}
            height={120}
            className="h-25 w-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Partners;
